import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UtilityService } from '../services/utility.service';
import { error } from 'selenium-webdriver';
import { AngularFireAuth } from 'angularfire2/auth';
import { ExtraService } from '../services/extra.service';
import { Constants } from '../config/Constants';


@Injectable()
export class AuthguardGuard implements CanActivate {

  authState: any = null;

  constructor(private utilityService: UtilityService,private router: Router,private extraService:ExtraService) { 
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      console.log(this.utilityService.isLogged());
      if(this.utilityService.isLogged()) {
        this.extraService.changeSideBar(true);
        this.extraService.changeStateofSideBarButton(true);
        return true;
      }else{
        this.router.navigate([Constants.LOGIN_URL]);
        return false;
      }
  }

  
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/guards/authguard.guard.ts